import React, {
  useRef,
  useState,
} from 'react';
import i18n from 'i18next';

import {
  placeCaretAtEnd,
} from 'web-utils';
import {
  useEntityDispatch,
  useProgramWorkout,
} from 'web-hooks';
import {
  Dropdown,
} from 'web-components';

import {
  Flex,
  SVG,
} from 'web-styled';

import * as S from '../styled';

type Props = {
  active: boolean,
  workout: number,
  readOnly: boolean,
  resourceType: string,
  draggableProvided: any,
  onClick: { (): void },
};

const WeekWorkout = ({
  active,
  workout,
  readOnly,
  resourceType,
  draggableProvided,
  onClick,
}: Props) => {
  const workoutType = resourceType === 'programTemplates'
    ? 'workoutTemplates'
    : 'personalWorkouts';
  const {
    saveWorkout,
    deleteWorkout,
    duplicateWorkout,
  } = useProgramWorkout({
    workoutId: workout.workout_id,
    programId: workout.program_id,
    programWorkoutId: workout.id,
    resourceType: workoutType,
  });
  const {
    updateEntity,
  } = useEntityDispatch({
    id: workout.workout_id,
    resourceType: workoutType,
  });
  const nameRef = useRef<HTMLDivElement>(null);
  const [nameIsEditable, setNameEditable] = useState<boolean>(false);

  const actions = [
    {
      name: 'Rename',
      onClick: () => {
        setNameEditable(true);
        setTimeout(() => {
          if (nameRef.current) {
            placeCaretAtEnd(nameRef.current);
            nameRef.current.scrollLeft = nameRef.current.scrollWidth;
          }
        }, 0);
      },
    },
    {
      name: 'Duplicate',
      onClick: duplicateWorkout,
    },
    {
      name: i18n.t('save.workout'),
      onClick: saveWorkout,
    },
    {
      name: 'Delete',
      color: '#e54d42',
      onClick: deleteWorkout,
    },
  ];

  const props = readOnly
    ? {}
    : {
      ref: draggableProvided.innerRef,
      ...draggableProvided.draggableProps,
    };

  return (
    <S.Workout
      {...props}
      active={active}
      onClick={onClick}
    >
      <S.Sort
        {...draggableProvided.dragHandleProps}
      >
        <SVG.MoveVertical size={14} />
      </S.Sort>

      {nameIsEditable
        ? (
          <S.EditableWorkoutName
            id={`id-${workout.id}`}
            html={workout.name}
            innerRef={nameRef}
            onBlur={(e) => {
              const newName = e.target.textContent || '';
              if (newName && newName !== workout.name) {
                updateEntity({
                  name: newName,
                });
              }
              setNameEditable(false);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.target.blur();
              }
            }}
          />
        ) : (
          <S.WorkoutName
            dangerouslySetInnerHTML={{ __html: workout.name }}
          />
        )}

      <Dropdown
        positions={['bottom']}
        trigger={(
          <Flex
            width="20px"
            height="30px"
            margin="0 10px 0 0"
          >
            <S.ContextMenu active={active} />
          </Flex>
        )}
        items={actions}
      />
    </S.Workout>
  );
};

export default WeekWorkout;
